(function ($) {
	if($.datepicker){
		var ref = $.datepicker._showDatepicker;
		$.datepicker._showDatepicker = function(input){
			var ret = ref(input);
			var inst = $.datepicker._getInst(input);
			var afterShow = $.datepicker._get(inst, 'afterShow');
			if(afterShow){
				afterShow.apply(input, [input, inst])
			}
			return ret;
		}
	}
})(jQuery);